module.exports = __webpack_public_path__ + "img/16.19d86807.png";